import { Box } from "@mui/material";
import { RemediationScriptFieldsFragment } from "~/operations";
import { RemediationTabContent } from "~/components/DetailsPage/components/Remediation/RemediationTabContent";
import { RemediationTabs } from "~/components/DetailsPage/components/Remediation/RemediationTabs";
import { useRemediationScripts } from "~/components/DetailsPage/components/Remediation/hooks/useRemediationScripts";
import { RemediationScriptsSkeleton } from "~/components/Remediation/RemediationFilter/RemediationScriptsSkeleton";

type SoftwareRemediationProps = {
  scripts: Array<RemediationScriptFieldsFragment>;
  loading: boolean;
  onCopy?: () => void;
};

export const RemediationScripts = ({
  scripts,
  loading,
  onCopy,
}: SoftwareRemediationProps) => {
  const { scriptTab, handleChangeScriptTab } = useRemediationScripts();

  return (
    <>
      <Box sx={{ width: "100%" }} data-testid="remediation-scripts">
        {!loading && (
          <RemediationTabs
            onScriptTabChange={handleChangeScriptTab}
            scriptTab={scriptTab}
            scripts={scripts}
          />
        )}
        {loading ? (
          <Box mt={5}>
            <RemediationScriptsSkeleton />
          </Box>
        ) : (
          <>
            {scripts.map((script, index) => (
              <RemediationTabContent
                value={scriptTab}
                index={index}
                key={index}
                script={script}
                onCopy={onCopy}
              />
            ))}
          </>
        )}
      </Box>
    </>
  );
};
